export default "__VITE_ASSET__BHXVoLf8__"